import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfirmationService, MessageService} from 'primeng/api';
import {NetworkService} from '../../../services/network.service';
import {getUrlImplante} from '../../../controller/staticValues';
import {Util} from '../../../controller/Util';

// Empresa do cliente (e filiais) com a situacao do SNGPC. Vem do implanteServer
// (sngpcadm), que so aceita usuario de suporte.
export interface EmpresaSngpc {
    IdEmpresa: number;
    RazaoSocial: string;
    NomeFantasia: string;
    Cnpj: string;
    Matriz: boolean;
    SngpcAtivo: boolean;
    IntegrationKey: string;
    UrlApi: string;
}

// Liga o SNGPC por empresa e mostra a chave que a farmacia cadastra no
// toqSNGPC (Integracao ERP: "URL da API" e "API Token").
@Component({
    selector: 'app-sngpc-cliente-toqsys',
    templateUrl: './sngpc-cliente-toqsys.component.html',
    styleUrls: ['./sngpc-cliente-toqsys.component.css'],
    standalone: false
})
export class SngpcClienteToqsysComponent implements OnInit {

    idCliente = 0;
    cliente: any = {};
    empresas: EmpresaSngpc[] = [];
    carregando = false;
    // chaves visiveis na tela (por IdEmpresa); por padrao ficam mascaradas
    chaveVisivel: { [id: number]: boolean } = {};
    // evita duplo clique enquanto a chamada nao volta
    ocupado: { [id: number]: boolean } = {};

    constructor(private route: ActivatedRoute, private router: Router, private networkService: NetworkService,
                private messageService: MessageService, private confirmationService: ConfirmationService) {
    }

    ngOnInit() {
        this.route.paramMap.subscribe(params => {
            this.idCliente = Number(params.get('id') || 0);
            if (!this.idCliente) {
                return;
            }
            this.networkService.buscar('CLIENTE_TOQSYS', this.idCliente, '', getUrlImplante())
                .subscribe(c => this.cliente = c || {});
            this.carregar();
        });
    }

    carregar() {
        this.carregando = true;
        this.networkService.getSimples(getUrlImplante(), `sngpcadm/ListarEmpresasSngpc?IdCliente=${this.idCliente}`)
            .subscribe((res: any) => this.empresas = res?.value ?? res ?? [])
            .add(() => this.carregando = false);
    }

    alternarAtivo(e: EmpresaSngpc) {
        const ativar = !e.SngpcAtivo;
        const nome = e.NomeFantasia || e.RazaoSocial;
        this.confirmationService.confirm({
            key: 'sngpc',
            header: ativar ? 'Ligar SNGPC' : 'Desligar SNGPC',
            message: ativar
                ? `Ligar o SNGPC para <b>${nome}</b>?<br><br>As telas de medicamento controlado aparecem no toqWEB desta empresa. Se ainda nao houver chave, uma sera gerada.`
                : `Desligar o SNGPC de <b>${nome}</b>?<br><br>O toqSNGPC perde o acesso aos dados na hora. A chave e mantida: ao religar, volta a valer.`,
            accept: () => this.enviar(e, 'sngpcadm/AtivarSngpc',
                {IdCliente: this.idCliente, IdEmpresa: e.IdEmpresa, Ativo: ativar},
                ativar ? 'SNGPC ligado.' : 'SNGPC desligado.')
        });
    }

    gerarNovaChave(e: EmpresaSngpc) {
        const nome = e.NomeFantasia || e.RazaoSocial;
        this.confirmationService.confirm({
            key: 'sngpc',
            header: 'Gerar nova chave',
            message: `Gerar uma nova chave para <b>${nome}</b>?<br><br>A chave atual <b>para de funcionar na hora</b>: a farmacia precisa colar a nova no toqSNGPC (Integracao ERP, campo API Token).`,
            accept: () => this.enviar(e, 'sngpcadm/GerarNovaChaveSngpc',
                {IdCliente: this.idCliente, IdEmpresa: e.IdEmpresa}, 'Nova chave gerada.', true)
        });
    }

    private enviar(e: EmpresaSngpc, rota: string, corpo: Object, msg: string, mostrarChave = false) {
        this.ocupado[e.IdEmpresa] = true;
        this.networkService.salvarPost(getUrlImplante(), rota, corpo)
            .subscribe((atualizada: any) => {
                if (!atualizada || !atualizada.IdEmpresa) {
                    return;
                }
                this.empresas = this.empresas.map(x => x.IdEmpresa === atualizada.IdEmpresa ? atualizada : x);
                if (mostrarChave) {
                    this.chaveVisivel[atualizada.IdEmpresa] = true;
                }
                this.messageService.add(Util.pushSuccessMsg(msg));
            })
            .add(() => this.ocupado[e.IdEmpresa] = false);
    }

    chaveExibida(e: EmpresaSngpc): string {
        if (!e.IntegrationKey) {
            return '';
        }
        if (this.chaveVisivel[e.IdEmpresa]) {
            return e.IntegrationKey;
        }
        return e.IntegrationKey.substring(0, 4) + '••••••••••••' + e.IntegrationKey.slice(-4);
    }

    copiar(texto: string, oQue: string) {
        if (!texto) {
            return;
        }
        navigator.clipboard.writeText(texto)
            .then(() => this.messageService.add(Util.pushSuccessMsg(`${oQue} copiada.`)))
            .catch(() => this.messageService.add(Util.pushErrorMsg(`Nao foi possivel copiar. Selecione e copie a ${oQue.toLowerCase()} manualmente.`)));
    }

    voltar() {
        this.router.navigate(['lista-cliente-toqsys']);
    }
}
